import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FormControl, NativeSelect, InputLabel } from '@material-ui/core';
import { PaymentTypes } from 'common/constants';

const styles = theme => ({
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 200,
        marginLeft: 0
    }
});

export default withStyles(styles)(class PaymentTypeSelectField extends Component {
    
    // need to read all of the states and on init
    constructor(props) {
        super(props);
        this.states = { ...PaymentTypes };
    }

    handleChange = (event) => {
        this.props.onChange({
            target: {
                id: event.target.name,
                value: event.target.value
            }
        })
    }

    menuItems() {
        return Object.keys(this.states).map((key) => (
            <option value={key} key={key}>{this.states[key]}</option>
        ));
    }

    render() {
        const { value, classes } = this.props;
        return (
            <div>
                <FormControl className={classes.formControl}>
                    <InputLabel shrink={true} htmlFor="paymentType">Payment Type</InputLabel>
                    <NativeSelect native="true" inputProps={{
                        name: 'paymentType',
                        id: 'paymentType',
                        value
                    }}
                        onChange={this.handleChange}>
                        {this.menuItems()}
                    </NativeSelect>
                </FormControl>
            </div>);
    }
});